import { SORT_TYPE } from 'constants/common'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as UseStyled from 'features/report/useStyled'
import TableRowExport from 'component/Pdf/TableRowExport'
import TableRowCommon from 'component/Table/TableRowCommon'
import { dateToView } from 'utils/date.utils'
import { Box, Typography } from '@mui/material'
import TableCustom from 'component/Table/TableCustom'
import { numberFormat, toBuddhistYear } from 'utils/app.utils'
import moment from 'moment'
import _ from 'lodash'
import { colors } from 'constants/theme'
import { UseSnCode } from 'utils/useSnCode'

interface PatientTypesListProps {
    page: number
    pageLimit: number
    rowCount: number
    data: any
    dataExport: any
    handleChangeRowsPerPage: (val: any) => void
    handleChangePage: (val: any) => void
    onRequestSort: (sortBy: string, sortType: string) => void
    setSortType: (val: SORT_TYPE) => void
    setSortBy: (val: string) => void
    sortType: string
    sortBy: string
    componentRef: any
    branchName: string
    rangeDate: string[]
    rowsGroup: any
    patientTypeSelect: () => string
}

const PatientTypesList = (props: PatientTypesListProps) => {
    const { t } = useTranslation()

    const [dataIncome, setDataIncome] = useState<any>([])
    const [dataExpense, setDataExpense] = useState<any>([])
    const [snType, setSnType] = useState(false)

    const handleSnCode = useCallback(() => {
        const fetchData = async () => {
            const sn = await UseSnCode()
            setSnType(sn)
        }

        fetchData()
    }, [snType])

    useEffect(() => {
        handleSnCode()
    }, [])

    const onRequestSort = (sortByVal: string, sortTypeVal: SORT_TYPE) => {
        props.setSortType(sortTypeVal)
        props.setSortBy(sortByVal)
        props.handleChangePage(1)
    }

    const headCells = [
        { id: '1', disablePadding: false, labelKey: t('REPORT.TABLE.FOLLOW_UP.#'), align: 'center', class: 'text-nowrap', width: '30px', },
        { id: '2', disablePadding: false, labelKey: t('REPORT.FILTER.BRANCH'), align: 'left', class: 'text-nowrap', },
        { id: '3', disablePadding: false, labelKey: t('REPORT.TABLE.REMUNERATION.PATIENT_CN_NUMBER'), align: 'center', class: 'text-nowrap', width: '150px', },
        { id: '4', disablePadding: false, labelKey: t('REPORT.TABLE.NEW_PATIENT.PATIENT_CN_NUMBER'), align: 'center', class: 'text-nowrap', width: '150px', },
        { id: '5', disablePadding: false, labelKey: t('REPORT.TABLE.REMUNERATION.PATIENT_SN_CODE'), align: 'center', class: 'text-nowrap', width: '150px', },
        { id: '6', disablePadding: false, labelKey: t('REPORT.TABLE.REMUNERATION.PATIENT_NAME'), align: 'left', class: 'text-nowrap', },
        { id: '7', disablePadding: false, labelKey: t("REPORT.TABLE.NEW_PATIENT.GENDER"), align: 'center', class: 'text-nowrap', width: '100px', },
        { id: '8', disablePadding: false, labelKey: t("REPORT.TABLE.PATIENT.MOBILE"), align: 'left', class: 'text-nowrap', width: '150px', },
        { id: '9', disablePadding: false, labelKey: t("REPORT.TABLE.PATIENT.PATIENT_TYPE"), align: 'left', class: 'text-nowrap', },
    ]


    if (!snType) {
        headCells.splice(4, 1)
    }

    const renderData = (data: any, no: number, exportData: boolean, render: 'data' | 'sum') => {
        const num = exportData === true ? no + 1 : props.page * props.pageLimit - props.pageLimit + no + 1

        const { branchName, cnNumber, branchCnNumber, snCode, expenseGroup, expenseTypeName, phone, prefixName, patientName, patientTypeName, gender } = data

        const objRenderData = {
            key: num.toString(),
            id: no.toString(),
            obj: data,
            columns: [
                { option: 'TEXT', align: 'center', label: num, class: 'text-nowrap' },
                { option: 'TEXT', align: 'left', label: branchName, class: 'text-nowrap' },
                { option: 'TEXT', align: 'center', label: cnNumber, class: 'text-nowrap' },
                { option: 'TEXT', align: 'center', label: branchCnNumber, class: 'text-nowrap' },
                { option: 'TEXT', align: 'center', label: snCode, class: 'text-nowrap' },
                { option: 'TEXT', align: 'left', label: `${patientName}`, class: 'text-nowrap' },
                { option: 'TEXT', align: 'center', label: t(`REPORT.VALUE.PATIENT.GENDER.${gender}`), class: 'text-nowrap' },
                { option: 'TEXT', align: 'left', label: phone, class: 'text-nowrap' },
                { option: 'TEXT', align: 'left', label: patientTypeName || 'ไม่ระบุประเภทผู้ป่วย', class: 'text-nowrap' },
            ]
        }
        if (!snType) {
            objRenderData.columns.splice(4, 1)
        }
        return <>{(exportData === true && <TableRowExport {...objRenderData} />) || <TableRowCommon {...objRenderData} />}</>
    }

    const headCellsSub = [
        { id: '1', disablePadding: false, labelKey: t('REPORT.TABLE.PATIENT.PATIENT_TYPE'), align: 'left', class: 'text-nowrap', },
        { id: '2', disablePadding: false, labelKey: t("REPORT.TABLE.ACCESS_CHANNEL.COUNT"), align: 'center', class: 'text-nowrap', width: '150px', },
    ]

    const renderDataIncomeExpense = (data: any, no: number, exportData: boolean, render: 'data' | 'sum') => {
        const { patientTypeName, total } = data

        if (render === 'data' && patientTypeName) {
            const objRenderData = {
                key: (no + 1).toString(),
                id: no.toString(),
                obj: data,
                columns: [
                    { option: 'TEXT', align: 'left', label: patientTypeName || t('REPORT.TABLE.PATIENT_TYPES.NONE'), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'center', label: total, class: 'text-nowrap' },
                ]
            }

            return <>{(exportData === true && <TableRowExport {...objRenderData} />) || <TableRowCommon {...objRenderData} />}</>
        }

    }

    return (
        <>
            <Box>
                <UseStyled.ResponsiveReportTable>
                    <TableCustom
                        rowHeadCell={2}
                        // tableMinWidth={992}
                        page={props.page}
                        pageLimit={props.pageLimit}
                        sortType={props.sortType}
                        sortBy={props.sortBy}
                        rowCount={props.rowCount}
                        onSort={onRequestSort}
                        setPageLimit={props.handleChangeRowsPerPage}
                        setPage={props.handleChangePage}
                        headCells={headCells}
                        rowsData={props.data?.length ? [
                            _.map(props.data, (d: any, index: number) => {
                                return renderData(d, index, false, 'data')
                            }),
                        ] : []}
                        customScroll
                    />
                </UseStyled.ResponsiveReportTable>
            </Box>
            <Box marginTop='32px'>
                <Box maxWidth='900px' sx={!props?.rowsGroup?.length ? { tr: { td: { textAlign: 'center' } } } : {}}>
                    <UseStyled.ResponsiveReportTable>
                        <TableCustom
                            rowHeadCell={2}
                            page={props.page}
                            pageLimit={props.pageLimit}
                            sortType={props.sortType}
                            sortBy={props.sortBy}
                            rowCount={props.rowCount}
                            onSort={onRequestSort}
                            setPageLimit={props.handleChangeRowsPerPage}
                            setPage={props.handleChangePage}
                            headCells={headCellsSub}
                            rowsData={
                                props?.rowsGroup?.length ? [
                                    _.map(props?.rowsGroup, (d: any, index: number) => {
                                        return renderDataIncomeExpense(d, index, false, 'data')
                                    }),
                                ] : []}
                            customScroll
                            hidePagination
                        />
                    </UseStyled.ResponsiveReportTable>
                </Box>
            </Box>

            <div id="print-table-container" ref={props.componentRef}>
                <ExportData
                    headCells={t(`REPORT.REPORT_NAME.PATIENT_TYPES`)}
                    branchName={props.branchName}
                    patientTypeSelect={props.patientTypeSelect}
                    componant={
                        <Box sx={{
                            'tbody tr:last-child td': {
                                paddingBottom: '8px'
                            },
                            '.merge-colspan': {
                                borderRight: 'none !important',
                            },
                            '.sum-colspan': {
                                borderLeft: 'none !important',
                            },
                            'td': {
                                border: '1px ridge rgb(0, 0, 0) !important',
                                padding: '1px 4px !important'
                            },
                            '.col-sum': { borderLeft: '0px solid !important' },
                            '.col-merge': { borderRight: '0px solid !important' }
                        }}>
                            <UseStyled.Styles className="pt-3">
                                <table style={{ tableLayout: 'fixed', borderCollapse: 'collapse', minWidth: '100%', maxWidth: '100%', border: '1px solid' }}>
                                    <thead>
                                        <tr>
                                            {_.map(headCells, (val: any, index: number) => {
                                                return <td style={{ textAlign: val.align, fontSize: 8, fontWeight: 500, height: '36px', ...val?.style }}> {t(val.labelKey)}</td>
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.dataExport?.length ? [
                                            _.map(props.dataExport, (d: any, index: number) => {
                                                return renderData(d, index, true, 'data')
                                            }),
                                        ] : <tr><td colSpan={headCells.length} style={{ textAlign: 'center', fontSize: 8, fontWeight: 500, height: '36px' }}>{t('NOT_FOUND')}</td></tr>}
                                    </tbody>
                                </table>
                            </UseStyled.Styles>

                            <Box sx={{ marginTop: '20px', '.box-table': { width: '500px' } }}>
                                <UseStyled.Styles className="pt-3 box-table">
                                    <table style={{ tableLayout: 'fixed', borderCollapse: 'collapse', minWidth: '100%', maxWidth: '100%', border: '1px solid' }}>
                                        <thead>
                                            <tr>
                                                {_.map(headCellsSub, (val: any, index: number) => {
                                                    return <td style={{ textAlign: val.align, fontSize: 8, fontWeight: 500, height: '36px', ...val?.style }}> {t(val.labelKey)}</td>
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {props?.rowsGroup?.length ? [
                                                _.map(props?.rowsGroup, (d: any, index: number) => {
                                                    return renderDataIncomeExpense(d, index, true, 'data')
                                                }),
                                                renderDataIncomeExpense(props?.rowsGroup, 0, true, 'sum')
                                            ] : <tr><td colSpan={headCellsSub.length} style={{ textAlign: 'center', fontSize: 8, fontWeight: 500, height: '36px' }}>{t('NOT_FOUND')}</td></tr>}
                                        </tbody>
                                    </table>
                                </UseStyled.Styles>
                            </Box>


                        </Box>
                    }
                />
            </div>
        </>
    )
}

export default PatientTypesList

type ExportDataDecreaseListProps = {
    headCells: string
    branchName: string
    componant: any
    patientTypeSelect: () => string
}

export function ExportData(props: ExportDataDecreaseListProps) {
    const { t } = useTranslation()

    return (
        <>
            <Box sx={{ fontSize: '14px', fontWeight: "500" }}>{props.headCells}</Box>
            <Box sx={{ display: "flex", alignItems: 'center', gap: '8px' }}>
                <Box sx={{ fontSize: '10px' }}>{t('REPORT.TABLE.DECREASE.BRANCH')}: {props.branchName}</Box>
                <Box sx={{ fontSize: '10px' }}>{t('REPORT.TABLE.PATIENT.PATIENT_TYPE')}: {props.patientTypeSelect()}</Box>
            </Box>

            {props.componant}
        </>
    )
}